
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/augments",
      function () {
        return require("private-next-pages/info/augments.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/augments"])
      });
    }
  